import { useEffect, useRef } from 'react';
import { subscribeToEvent, unsubscribeFromEvent } from '../../../services/deepstream';
import { useCurrentBoard } from '../../../services/state';

const NodeDragImage = ({ userId, nodeId }) => {
  const { id: boardId } = useCurrentBoard();
  const dragImage = useRef(null);

  useEffect(() => {
    const mouseMoveEvent = `project/${boardId}/user/${userId}/mousemove`;

    const updateMousePosition = ({ percentageX, percentageY }) => {
      if (dragImage.current) {
        dragImage.current.style.top = `calc(${percentageY}% - 20px)`;
        dragImage.current.style.left = `calc(${percentageX}% - 20px)`;
        dragImage.current.style.display = 'block';
      }
    };

    subscribeToEvent(mouseMoveEvent, updateMousePosition);

    return () => {
      unsubscribeFromEvent(mouseMoveEvent, updateMousePosition);
    };
  }, [userId, boardId]);

  useEffect(() => {
    if (!nodeId) return;

    const draggedNodeElement = document.getElementById(`graph-node-${nodeId}`);
    if (!draggedNodeElement) return;

    dragImage.current = draggedNodeElement.cloneNode(true);
    dragImage.current.style.transition = 'all 0.1s linear';
    dragImage.current.style.display = 'none';
    dragImage.current.style.opacity = 0.8;
    document.body.appendChild(dragImage.current);

    return () => {
      if (dragImage.current) {
        document.body.removeChild(dragImage.current);
        dragImage.current = null;
      }
    };
  }, [nodeId]);

  return null;
};

export default NodeDragImage;
